import { DBFactory } from "~/classes/database/db_factory";
import { BaseModel } from "../base.model";

type UserRoleConstructorParam = {
  id?: string;
  name: string;
  description: string;
  userPermissions: string[];
};

export type UserRoles = UserRole[];

export class UserRole extends BaseModel {
  id?: string;
  name: string;
  description: string;
  userPermissions: string[];

  constructor({
    id,
    name,
    description,
    userPermissions,
  }: UserRoleConstructorParam) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.userPermissions = userPermissions;
  }
  
  get databaseConfig() {
    return {
      path: `userRoles/${this.id}`,
      collection: "/userRoles",
    };
  }

  static fromMap(map: any): UserRole {
    return new UserRole(map);
  }

  async save() {
    const db = DBFactory.createDatabase();
    this.id = await db.save(this.toMap(), this.databaseConfig);
  }
}
